export default __webpack_public_path__ + "static/media/ic_html_css.2e24040e.png";